export var MOBILE_MIN_WIDTH_BREAKPOINTS = {
  SMALL: 320,
  MEDIUM: 375
};